$(function() {
  const $banner = $('#js-qr-banner');
  const $closeBtn = $('#js-qr-banner__close');
  let isClosed = false;

  $closeBtn.on('click', (e) => {
    e.preventDefault();
    $banner.addClass('is-hidden');
    isClosed = true;
  });

  const toggle = () => {
    if (isClosed) return;
    if ($(window).width() <= 768) {
      $banner.addClass('is-visible');
    }
  };

  $(window).on('resize', toggle);
  toggle();
});
